import Club from "../models/Club";
import {fetchClubDataFromDatabase, updateClubDataInDatabase} from "./databasehandler";

export const getClubData = async (clubId) => {
    const result = await fetchClubDataFromDatabase(clubId);
    if (result) {
        return result.map((club) => new Club(
            club.club,
            club.shortClub,
            club.contact,
            club.phone,
            club.address,
            club.mail
        ))[0];
    }
    return null;
}

export const updateClubData = async (clubId, club, shortClub, contact, phone, address, mail) => {
    const clubData = new Club(club, shortClub, contact, phone, address, mail);
    return await updateClubDataInDatabase(clubId, clubData);
}